module.exports = __webpack_public_path__ + "img/66_1.7a6a0962.png";